
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCloudBolt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import {
  ExclamationCircleIcon,
  CheckCircleIcon,
  PlusIcon,
  FlagIcon,
  EllipsisVerticalIcon,
  TrashIcon,
} from "@heroicons/vue/24/solid";
import { useProjectDurationSettings } from "@oculai/planner";
import { format, parseISO, isToday, parse, isSameDay, isWithinInterval, getDate } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { defineComponent, PropType } from "vue";
import { useCurrentProject } from "@/composables/project";
import { apiClient } from "@/repositories/clients";
import { OverviewItem } from "@/types/DailyReport";

const parseUtcDate = (dateText: string) => utcToZonedTime(parseISO(dateText), "UTC");

library.add(faCloudBolt);
export default defineComponent({
  setup() {
    const project = useCurrentProject();
    const { projectDurationSettings } = useProjectDurationSettings(apiClient);

    return { projectDurationSettings, project };
  },
  props: {
    date: {
      type: String as PropType<string>,
      required: true,
    },
    data: {
      type: Object as PropType<OverviewItem["data"]>,
      required: true,
    },
  },
  emits: ["initializeReport", "deleteReport"],
  components: {
    ExclamationCircleIcon,
    CheckCircleIcon,
    EllipsisVerticalIcon,
    PlusIcon,
    FlagIcon,
    TrashIcon,
    FontAwesomeIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
  },

  computed: {
    hasReport() {
      return this.data.report.status !== "NOT_AVAILABLE";
    },
    isToday() {
      return isToday(parse(this.date, "yyyy-MM-dd", new Date()));
    },
    isProjectStart() {
      return isSameDay(parse(this.date, "yyyy-MM-dd", new Date()), this.project.planned_start);
    },
    isProjectEnd() {
      return isSameDay(parse(this.date, "yyyy-MM-dd", new Date()), this.project.planned_end);
    },
    holidaysForDate() {
      return this.projectDurationSettings
        ? this.projectDurationSettings.non_working_days.filter(
            (item: { start_date: Date; end_date: Date }) =>
              isWithinInterval(parse(this.date, "yyyy-MM-dd", new Date()), {
                start: item.start_date,
                end: item.end_date,
              }),
          )
        : [];
    },
  },

  methods: {
    formatTime(dateString: string) {
      return format(parseUtcDate(dateString), "HH:mm");
    },
    formatIsoTimestamp(timestamp: string) {
      return format(parseISO(timestamp), "dd.MM.yyyy HH:mm:ss");
    },
    formatDate(date: string) {
      return format(parseISO(date), "dd.MM.yyyy");
    },
    formatDateToDay(date: string) {
      return getDate(parseISO(date));
    },
  },
});
